import { useEffect, useState } from 'react';
import { getPartnershipSettings, updatePartnershipSettings } from '../../parts/api';

const PartnershipSettingsAdmin = () => {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState('');
  const [statusType, setStatusType] = useState('success');

  useEffect(() => {
    getPartnershipSettings()
      .then((settings) => setEnabled(settings?.pelicanPartsLinksEnabled === true))
      .catch((error) => {
        setStatus(error.message || 'Failed to load partnership settings.');
        setStatusType('error');
      })
      .finally(() => setLoading(false));
  }, []);

  const toggle = async (nextEnabled) => {
    const previous = enabled;
    setEnabled(nextEnabled);
    setSaving(true);
    setStatus('');
    try {
      const saved = await updatePartnershipSettings({ pelicanPartsLinksEnabled: nextEnabled });
      const persisted = saved?.pelicanPartsLinksEnabled === true;
      setEnabled(persisted);
      setStatus(`Pelican Parts purchase links are ${persisted ? 'ON' : 'OFF'}.`);
      setStatusType('success');
    } catch (error) {
      setEnabled(previous);
      setStatus(error.message || 'Failed to update partnership settings.');
      setStatusType('error');
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="admin-module-pricing admin-partnership-settings">
      <div className="admin-partnership-heading">
        <div>
          <h3>Pelican Parts Partnership</h3>
          <p>Master control for Pelican purchase links and catalog-price visibility.</p>
        </div>
        <strong className={enabled ? 'partnership-state on' : 'partnership-state off'}>
          {enabled ? 'ON' : 'OFF'}
        </strong>
      </div>
      {status && (
        <div className={statusType === 'error' ? 'error-banner' : 'success-banner'} role="status">
          {status}
        </div>
      )}
      {loading ? <p>Loading partnership settings...</p> : (
        <label className="checkbox-field partnership-master-switch">
          <input
            type="checkbox"
            checked={enabled}
            disabled={saving}
            onChange={(event) => toggle(event.target.checked)}
          />
          <span>
            <strong>Enable Pelican Parts collaboration</strong>
            <small>On: purchase links enabled and catalog prices hidden. Off: links disabled and existing prices restored.</small>
          </span>
        </label>
      )}
      {saving && <p>Saving partnership setting...</p>}
    </section>
  );
};

export default PartnershipSettingsAdmin;
